<template>
  <div class="fc-selected-day" :class="selectedClass" :style="`${eventStyle}`">
    <slot></slot>
    <i class="el-icon-remove" @click="$emit('cellRemoved')"></i>
  </div>
</template>
<script>
// import { parseDateTimeToLocal } from '@/utils/date'
export default {
  props: {
    roomId: null,
    date: null,
    selectedRooms: null,
    minDayCellWidth: {
      required: true,
      default: () => 0
    },
    day: {
      required: true,
      default: () => {
        return {
          start: null,
          end: null,
          offsetTop: 0,
          offsetLeft: 0
        }
      }
    }
  },
  data() {
    return {
      selectedClass: null
    }
  },
  computed: {
    eventStyle() {
      const width =
        (this.day.end.diff(this.day.start, 'days') + 1) * this.minDayCellWidth
      const style = `
      left: ${this.day.offsetLeft}px;
      top: ${this.day.offsetTop}px;
      width: ${width}px;`
      return style
    }
  }
}
</script>
<style>
.fc-selected-day {
  position: absolute;
  background-color: rgba(var(--das-color-amber), 0.2);
  border: 1px solid rgb(var(--das-color-amber));
  height: calc(var(--das-fc-cell-height) - 1px);
  z-index: 20;
}
.fc-selected-day .el-icon-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  color: rgb(var(--das-color-amber));
  cursor: pointer;
}
.fc-selected-day .el-icon-remove:before {
  font-size: 20px;
}
</style>
